import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CAROUSELSLIDECARDBLOCK_LEGACY_FIELD_ORDER = [
  "link_url",
  "tag",
  "background_image",
  "background_color",
  "width",
  "aspect-ratio",
  "height"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  carouselSlideCardBlockDescriptor: _generatedCarouselSlideCardBlockDescriptor,
  carouselSlideCardBlockBlocDefinition,
  carouselSlideCardBlockDashboardLayout,
  carouselSlideCardBlockConfig,
  carouselSlideCardBlockResolveConfig,
  carouselSlideCardBlockProperties,
} = doodBlockConfig(
  {
    name: "Carousel - Slide card",
    componentType: 'CarouselSlideCardBlockComponent',
    category: 'content',
    description: "Carousel - Slide card.",
    keywords: [],
    allowedIn: [
      { bloc: "CarouselBlockComponent", slot: "slides" },
    ],
    sharedFields: {}
  },

  () => ({
    link_url: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.carousel-slide-card.link-url.label",
      }
    }),
    tag: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.carousel-slide-card.tag.label",
        help: "pages.blocks.carousel-slide-card.tag.help",
      }
    }),
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.carousel-slide-card.background-image.label",
        help: "pages.blocks.carousel-slide-card.background-image.help",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-200"},
      options: {
        label: "pages.blocks.carousel-slide-card.background-color.label",
      }
    }),
    width: propertyValue({
      type: 'select',
      value: "3/12",
      options: {
        label: "pages.blocks.carousel-slide-card.width.label",
        help: "pages.blocks.carousel-slide-card.width.help",
        choices: [
          {
            value: "3/12",
            label: "pages.blocks.carousel-slide-card.width.options.3-12",
          },
          {
            value: "4/12",
            label: "pages.blocks.carousel-slide-card.width.options.4-12",
          },
          {
            value: "6/12",
            label: "pages.blocks.carousel-slide-card.width.options.6-12",
          },
          {
            value: "12/12",
            label: "pages.blocks.carousel-slide-card.width.options.12-12",
          }
        ]
      }
    }),
    "aspect-ratio": propertyValue({
      type: 'text',
      value: '1',
      description: "pages.blocks.carousel-slide-card.aspect-ratio.help",
      options: {
        label: "pages.blocks.carousel-slide-card.aspect-ratio.label",
        help: "pages.blocks.carousel-slide-card.aspect-ratio.help",
      }
    }),
    height: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.carousel-slide-card.height.label",
        help: "pages.blocks.carousel-slide-card.height.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.carousel-slide-card.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.carousel-slide-card.fieldset.link.label",
            fields: ["link_url"],
          },
          {
            legend: "pages.blocks.carousel-slide-card.fieldset.tag.label",
            fields: ["tag"],
          },
          {
            legend: "pages.blocks.carousel-slide-card.fieldset.image.label",
            fields: ["background_image", "background_color"],
          },
          {
            legend: "pages.blocks.carousel-slide-card.fieldset.size.label",
            fields: ["width", "aspect-ratio", "height"],
          },
        ],
      },
    ],
  })
);

export function carouselSlideCardBlockDescriptor(): IBlockDescriptor;
export function carouselSlideCardBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function carouselSlideCardBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCarouselSlideCardBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCarouselSlideCardBlockDescriptor, carouselSlideCardBlockProperties, fieldOrder);
}

export {
  carouselSlideCardBlockBlocDefinition,
  carouselSlideCardBlockDashboardLayout,
  carouselSlideCardBlockProperties,
  carouselSlideCardBlockConfig,
  carouselSlideCardBlockResolveConfig,
};

export type CarouselSlideCardBlockConfig = typeof carouselSlideCardBlockConfig;
